import React from 'react';

import Modal from 'components/curo-components/common/Modal';
import Button from 'components/digifi-wrappers/Button';
import { DocumentIcon } from 'static/images';

interface IExistingApplicationWithoutOffer {
  onClose: () => void;
  onButtonClick: () => void;
}

const ExistingApplicationWithoutOffer = ({
  onButtonClick,
  onClose,
}: IExistingApplicationWithoutOffer) => {
  return (
    <Modal
      actionElement={
        <Button size="form" kind="primary" onClick={onButtonClick}>
          Click here to proceed
        </Button>
      }
      description="Great news! You already have an existing application."
      title="Welcome Back!"
      modalIcon={<DocumentIcon />}
      onClose={onClose}
    />
  );
};

export default ExistingApplicationWithoutOffer;
